import React, { useEffect, useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { SocketProvider } from 'common/context';
import { ERoute } from 'common/const';
import { CityProvider, ProtectedRoute, Sidebar, Spin } from 'common/components';
import { useJivo } from 'common/hooks';
import {
  ActiveBasketListPage,
  ActiveBasketPage,
  BasketPage,
  BrandCatalogsPage,
  CityListPage,
  InventoryListPage,
  ProfilePage,
  RequestListPage,
  RequestPage,
  // RfpDraftPage, // временно скрыто (RFP убран из интерфейса)
  // RfpListPage, // временно скрыто (RFP убран из интерфейса)
  // RfpPage, // временно скрыто (RFP убран из интерфейса)
  SettingsPage,
} from 'app/pages';
import { useAppDispatch, useAppSelector } from 'app/store/store.hooks';
// Временно скрыто у СА (роуты закомментированы ниже)
// import { PropertiesSettings } from 'entities/Property/components/PropertiesSettings';
// import { CatalogListSettings } from 'entities/Settings/components/CatalogListSettings';
// import { CatalogSettings } from 'entities/Settings/components/CatalogSettings';
import { AccountList } from 'entities/Account/components/AccountList';
import { ContractListForSuperAdmin } from 'entities/Contract/components/ContractListForSuperAdmin';
// import { MapperAdminPage } from 'entities/MapperAdmin/components/MapperAdminPage';
// import { TypeDetailPage } from 'entities/MapperAdmin/components/TypeDetailPage';
import { getUserRole } from 'entities/User/User.helper';
import { EUserRole } from 'entities/User/User.enum';
import { GoodPageWrapper } from 'entities/Goods/components';
import { detectCity } from 'entities/City/City.slice';
import { getCurrentUser, getUserStats } from 'entities/User/User.slice';
import { selectAuth, selectIsAuthLoading } from 'entities/Auth/Auth.slice';
import { CatalogWrapper } from 'entities/Catalog/components';

export const PrivateLayout: React.FC = () => {
  const dispatch = useAppDispatch();
  // auth
  const auth = useAppSelector(selectAuth);
  const isAuthLoading = useAppSelector(selectIsAuthLoading);

  const [fetchLoading, setFetchLoading] = useState<boolean>(true);

  const { isSuperAdmin } = getUserRole(auth?.access.roles);

  useJivo(auth);

  useEffect(() => {
    const fetch = async () => {
      setFetchLoading(true);

      if (auth) {
        await dispatch(getCurrentUser(auth.access.id));
        await dispatch(getUserStats());
        // Геоопределение города пользователя — один раз на верхнем уровне; модалка выбора города читает результат из стора.
        dispatch(detectCity());
      }

      setFetchLoading(false);
    };

    fetch();
  }, [auth]);

  if ((!auth && isAuthLoading) || fetchLoading) {
    return (
      <div className="h-full flex align-center justify-center">
        <Spin />
      </div>
    );
  }

  if (!auth && !isAuthLoading) {
    return <Navigate to={ERoute.Login} />;
  }

  if (auth?.access.isSelfRegistered && !auth?.access.selfRegistrationCompletedAt) {
    return <Navigate to={ERoute.SelfRegistration} />;
  }

  return (
    <CityProvider>
      <div className="private-layout">
        <Sidebar />

        <div className="private-layout__container">
          <Routes>
            {/* Временно скрыто у СА (вместе с пунктами меню в sidebar.helper.tsx) */}
            {/* <Route
              path={ERoute.CatalogList}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <CatalogListSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.CatalogListItem}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <CatalogSettings />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path={ERoute.BrandCatalogs}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <BrandCatalogsPage />
                </ProtectedRoute>
              }
            />
            {/* Временно скрыто у СА */}
            {/* <Route
              path={ERoute.PropertiesSettings}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <PropertiesSettings />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path={ERoute.AccountList}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <AccountList />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.ContractList}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <ContractListForSuperAdmin />
                </ProtectedRoute>
              }
            />
            {/* Временно скрыто у СА */}
            {/* <Route
              path={ERoute.MapperAdmin}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <Navigate to={ERoute.MapperAdminTypes} replace />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.MapperAdminTypes}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <MapperAdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.MapperAdminTypeDetail}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <TypeDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.MapperAdminMappings}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <MapperAdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.MapperAdminCatalog}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <MapperAdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.MapperAdminMatcher}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <MapperAdminPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.MapperAdminBrowser}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <MapperAdminPage />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path={`${ERoute.Settings}/:tab`}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SellerManager]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={`${ERoute.Settings}/:tab/:menu`}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={`${ERoute.Settings}/:tab/:id/:itemMenu`}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager]}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.ActiveBasketList}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager]}
                  condition={({ auth }) => !!auth?.access.isSeller}
                >
                  <ActiveBasketListPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.ActiveBasket}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager]}
                  condition={({ auth }) => !!auth?.access.isSeller}
                >
                  <ActiveBasketPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.Catalog}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager, EUserRole.Manager, EUserRole.HeadOfDepartment]}
                >
                  <CatalogWrapper />
                </ProtectedRoute>
              }
            >
              <Route path=":catalogId" element={<CatalogWrapper />}>
                <Route path=":categoryId" element={<CatalogWrapper />}>
                  <Route path="good/:goodId" element={<CatalogWrapper />} />
                </Route>
                <Route path="good/:goodId" element={<CatalogWrapper />} />
              </Route>
            </Route>
            <Route
              path={ERoute.Basket}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.Manager, EUserRole.HeadOfDepartment]}
                  condition={({ auth }) => !auth?.access.isSeller}
                >
                  <BasketPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={`${ERoute.RequestList}/:role`}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager, EUserRole.Manager, EUserRole.HeadOfDepartment]}
                  condition={({ auth, params }) => {
                    const { role } = params;
                    const roles = auth?.access.roles;

                    switch (role) {
                      case EUserRole.SellerManager: {
                        return (
                          !!roles?.includes(EUserRole.SellerManager) ||
                          !!(roles?.includes(EUserRole.AccountAdmin) && auth?.access.isSeller)
                        );
                      }
                      case EUserRole.Manager: {
                        return !!roles?.includes(EUserRole.Manager);
                      }
                      case EUserRole.User: {
                        return !auth?.access.isSeller;
                      }
                      default: {
                        return false;
                      }
                    }
                  }}
                >
                  <RequestListPage />
                </ProtectedRoute>
              }
            >
              <Route path=":tab1" element={<RequestListPage />}>
                <Route path=":tab2" element={<RequestListPage />} />
              </Route>
            </Route>
            <Route
              path={ERoute.Request}
              element={
                <SocketProvider
                  children={
                    <ProtectedRoute
                      allowedRoles={[
                        EUserRole.AccountAdmin,
                        EUserRole.SellerManager,
                        EUserRole.Manager,
                        EUserRole.HeadOfDepartment,
                      ]}
                      condition={({ auth }) => {
                        const isSeller = auth?.access.isSeller;
                        const { isUser } = getUserRole(auth?.access.roles);

                        if (isUser && isSeller) {
                          return false;
                        }

                        return true;
                      }}
                    >
                      <RequestPage />
                    </ProtectedRoute>
                  }
                />
              }
            />
            <Route
              path={ERoute.InventoryList}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.Manager, EUserRole.HeadOfDepartment]}
                  condition={({ auth }) => !auth?.access.isSeller}
                >
                  <InventoryListPage />
                </ProtectedRoute>
              }
            >
              <Route path=":tab" element={<InventoryListPage />} />
            </Route>
            <Route
              path={ERoute.Profile}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager, EUserRole.Manager, EUserRole.HeadOfDepartment]}
                >
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            {/* Временно скрыто (RFP убран из интерфейса и у СА, и у продавцов) */}
            {/* <Route
              path={`${ERoute.RfpList}/:role`}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.SuperAdmin, EUserRole.AccountAdmin, EUserRole.SellerManager]}
                  condition={({ auth }) => {
                    const isSeller = auth?.access.isSeller;
                    const { isSuperAdmin, isUser } = getUserRole(auth?.access.roles);

                    if (isSuperAdmin) {
                      return true;
                    }

                    if (isSeller && !isUser) {
                      return true;
                    }

                    return false;
                  }}
                >
                  <RfpListPage />
                </ProtectedRoute>
              }
            >
              <Route path=":tab" element={<RfpListPage />} />
            </Route>
            <Route
              path={ERoute.RfpDraft}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <RfpDraftPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.Rfp}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.SuperAdmin, EUserRole.AccountAdmin, EUserRole.SellerManager]}
                  condition={({ auth }) => {
                    const isSeller = auth?.access.isSeller;
                    const { isSuperAdmin, isUser } = getUserRole(auth?.access.roles);

                    if (isSuperAdmin) {
                      return true;
                    }

                    if (isSeller && !isUser) {
                      return true;
                    }

                    return false;
                  }}
                >
                  <RfpPage />
                </ProtectedRoute>
              }
            /> */}
            <Route
              path={ERoute.Good}
              element={
                <ProtectedRoute
                  allowedRoles={[EUserRole.AccountAdmin, EUserRole.SellerManager, EUserRole.Manager, EUserRole.HeadOfDepartment]}
                >
                  <GoodPageWrapper />
                </ProtectedRoute>
              }
            />
            <Route
              path={ERoute.CityList}
              element={
                <ProtectedRoute allowedRoles={[EUserRole.SuperAdmin]}>
                  <CityListPage />
                </ProtectedRoute>
              }
            />
            {/* TODO For future improvement */}
            {/* <Route path={ERoute.WorkspaceList} element={<WorkspaceListPage />} />
          <Route path={ERoute.NewWorkspacePosition} element={<PropertyProvider children={<NewWorkspacePositionPage />} />} />
          <Route path={ERoute.Workspace} element={<PropertyProvider children={<WorkspacePage />} />} /> */}

            {isSuperAdmin ? (
              <Route path="*" element={<Navigate to={ERoute.AccountList} />} />
            ) : (
              <Route path="*" element={<Navigate to={ERoute.Profile} />} />
            )}
          </Routes>
        </div>
      </div>
    </CityProvider>
  );
};
